import vue from "../../main";

export default class DefaultDelegationRateVehicle {
  constructor() {
    this.delegation_vehicle_under_900_rate = null;
    this.delegation_vehicle_above_900_rate = null;
    this.delegation_vehicle_moped_rate = null;
    this.delegation_vehicle_motorcycle_rate = null;

    // this.defaults = {
    //     delegation_vehicle_under_900_rate: "0.5214",
    //     delegation_vehicle_above_900_rate: "0.8358",
    //     delegation_vehicle_moped_rate: "0.1383",
    //     delegation_vehicle_motorcycle_rate: "0.2302"
    // };

    // this.rules = {
    //     delegation_vehicle_under_900_rate: [
    //         v => (v != null && v.length > 0) || 'Stawka jest wymagana'
    //     ],
    //     delegation_vehicle_above_900_rate: [
    //         v => (v != null && v.length > 0) || 'Stawka jest wymagana'
    //     ],
    //     delegation_vehicle_moped_rate: [
    //         v => (v != null && v.length > 0) || 'Stawka jest wymagana'
    //     ],
    //     delegation_vehicle_motorcycle_rate: [
    //         v => (v != null && v.length > 0) || 'Stawka jest wymagana'
    //     ]
    // };
  }

  defaults() {
    return {
      delegation_vehicle_under_900_rate: "0.5214",
      delegation_vehicle_above_900_rate: "0.8358",
      delegation_vehicle_moped_rate: "0.1383",
      delegation_vehicle_motorcycle_rate: "0.2302"
    };
  }

  rules() {
    return {
      delegation_vehicle_under_900_rate: [v => (v != null && v.length > 0) || vue.$t("global.error.required")],
      delegation_vehicle_above_900_rate: [v => (v != null && v.length > 0) || vue.$t("global.error.required")],
      delegation_vehicle_moped_rate: [v => (v != null && v.length > 0) || vue.$t("global.error.required")],
      delegation_vehicle_motorcycle_rate: [v => (v != null && v.length > 0) || vue.$t("global.error.required")]
    };
  }

  load() {
    vue.axios.get("settings/delegation-rate/get-delegation-vehicle-rate").then(resp => {
      this.delegation_vehicle_motorcycle_rate = resp.data.delegation_vehicle_motorcycle_rate.toString();
      this.delegation_vehicle_moped_rate = resp.data.delegation_vehicle_moped_rate.toString();
      this.delegation_vehicle_above_900_rate = resp.data.delegation_vehicle_above_900_rate.toString();
      this.delegation_vehicle_under_900_rate = resp.data.delegation_vehicle_under_900_rate.toString();
    });
  }

  save() {
    return new Promise((resolve, reject) => {
      vue.axios
        .post("settings/delegation-rate/save-delegation-vehicle-rate", this)
        .then(() => {
          resolve();
        })
        .catch(resp => {
          reject(resp.data);
        });
    });
  }
}
